export default ({ $axios }) => ({
  getPendingEmployeesApproval: async () => {
    try {
      const { data } = await $axios.get(
        '/v3/app/transfer/company/employees/pending-approval'
      )
      return data
    } catch (error) {
      console.error('Error getting pending employee approval', error)
      throw error
    }
  },
  getReportByIds: async (ids = []) => {
    try {
      const { data } = await $axios.post(
        '/v3/app/transfer/report/by-ids',
        { ids },
        { responseType: 'blob' }
      )
      return data
    } catch (error) {
      console.error('Error getting transfers report', error)
      throw error
    }
  },
  getOpenPeriodId: async () => {
    try {
      const { data } = await $axios.get('/v3/app/transfer/period/open/id')
      return data
    } catch (error) {
      console.error('Error getting open period id', error)
      throw error
    }
  },
  sendTransfersFile: async payload => {
    try {
      const { data } = await $axios.post(
        '/v3/app/transfer/file/upload',
        payload
      )
      return data
    } catch (error) {
      console.error('Error sending transfer file', error)
      throw error
    }
  },
  getLastUploadedFileStatus: async () => {
    try {
      const { data } = await $axios.get('/v3/app/transfer/file/last')
      return data
    } catch (error) {
      console.error('Error getting last transfer file status', error)
      throw error
    }
  },
  getNoVisitReasons: async () => {
    try {
      const { data } = await $axios.get('/v3/app/transfer/no-visit-reasons')
      return data
    } catch (error) {
      console.error('Error getting no visit reasons', error)
      throw error
    }
  },
  getHierarchyReport: async (periodId) => {
    try {
      const { data } = await $axios.get(
        `/v3/app/transfer/report/hierarchy/${periodId}`,
        { responseType: 'blob' }
      )
      return data
    } catch (error) {
      console.error('Error getting hierarchy report', error)
      throw error
    }
  },
})
